module.exports = __webpack_public_path__ + "media/images/avatar/13-ed3f063092895e1ad93aed8e69d632f0.svg";